module.exports = __webpack_public_path__ + "static/media/userBlack.89005c47.svg";